module.exports = __webpack_public_path__ + "img/upgrade_left.5d332fd3.png";